var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"top"},[_c('a',{staticClass:"header",attrs:{"href":"home.html"}},[_c('img',{staticClass:"icon",attrs:{"src":require("../assets/images/icon.png"),"alt":""}}),_c('img',{staticClass:"title_pic",attrs:{"src":require("../assets/images/title_pic.png"),"alt":""}})])])
}]

export { render, staticRenderFns }